var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound22D = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M7.6 22A1.6 1.6 0 0 1 6 20.4v-6.8A1.6 1.6 0 0 1 7.6 12h8.8a1.6 1.6 0 0 1 1.6 1.6v6.8a1.6 1.6 0 0 1-1.6 1.6H7.6ZM43.6 22a1.6 1.6 0 0 1-1.6-1.6v-6.8a1.6 1.6 0 0 1 1.6-1.6h8.8a1.6 1.6 0 0 1 1.6 1.6v6.8a1.6 1.6 0 0 1-1.6 1.6h-8.8ZM30 36a5 5 0 1 1 0-10 5 5 0 0 1 0 10ZM7.6 48A1.6 1.6 0 0 1 6 46.4V25.6A1.6 1.6 0 0 1 7.6 24h8.8a1.6 1.6 0 0 1 1.6 1.6v20.8a1.6 1.6 0 0 1-1.6 1.6H7.6ZM43.6 48a1.6 1.6 0 0 1-1.6-1.6V25.6a1.6 1.6 0 0 1 1.6-1.6h8.8a1.6 1.6 0 0 1 1.6 1.6v20.8a1.6 1.6 0 0 1-1.6 1.6h-8.8Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M21 48V18M57 48V18M3 48V18M39 48V18"
})));
SvgRound22D.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound22D);
export default ForwardRef;